import { AfterViewInit, Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[HideAfter]',
    standalone: true
})
export class HideAfterDirective implements AfterViewInit  {
    constructor(private elementRef: ElementRef) {}
    ngAfterViewInit(): void {
        setTimeout(() => {
          this.elementRef.nativeElement.style.transition = 'opacity 0.5s';
          this.elementRef.nativeElement.style.opacity = '0';
          setTimeout(() => {
            this.elementRef.nativeElement.style.display = 'none';
          }, 500); // délai pour l'animation de fade-out
        }, 5000); // délai avant de masquer le message
      }
      //TODO: si on essaye de ressoumettre le formulaire apres le message d'erreur, il ne s'affiche pas
    //   car il y a toujours les styles pour le masquer. donc il faudrait reset le style à un moement je pense.
}
